import { AddTOSBaseRequest } from './add.tos.base.request';

export class addTOSMacRequest extends AddTOSBaseRequest {

    AdminID: number;

    MacAddress: string;

    MemberID: number;

}
